import React from 'react';
import { Empty, Page, Refreshable, Scrollbar } from 'codeArt/components/Base';
import { Container } from 'codeArt/components/Layout';
import Portal from 'codeArt/components/Portal';
import { Avatar } from 'codeArt/components/Avatar';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined';
import { Board } from 'codeArt/external/components/Widget';
import { Html } from 'codeArt/components/Html';
import Button, { EditLink, ModalButton, SettingLink } from 'codeArt/components/Button';
import Modal, { Message } from 'codeArt/components/Modal';
import Form, { FormAction, FormCell, FormSection } from 'codeArt/components/Form';
import { TextBox } from 'codeArt/components/TextBox';
import { createIcon, Notification, Request, threePosition, Util, runtime } from 'codeArt/common';
import { Devices, FM01, FM02 } from 'app/constant';
import AirplayIcon from '@material-ui/icons/Airplay';
import ModuleSide from 'codeArt/components/ModuleSide';
import { onComparatorChange } from 'actions/Comparator';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';
import DataGrid, { DataCell, SearchBar } from 'codeArt/components/dataGrid';
import Select from 'codeArt/components/Select';
import { getRandom } from './common';

const WarningTypes = [
    { value: 1, text: "重量" },
    { value: 2, text: "圆周" },
    { value: 3, text: "跑条" }
]

function getWarningTypeText(value) {
    let item = WarningTypes.find((t) => t.value == value) || {};
    return item.text;
}

export class WarningContext extends React.Component {

    constructor(props) {
        super(props);
        WarningContext.current = this;
        this.searchArg = {};
        this.state = {
            data: []
        }
    }

    open() {
        this.setState({ data: this.getData() }, () => {
            this.modal.open();
        })
    }

    close() {
        this.modal.close();
    }

    // tools() {
    //     let { readOnly } = this.props;
    //     if (readOnly) return null;
    //     return [
    //         <ModalButton key={"close"} color="grey" onClick={() => { this.close(); }}>关闭</ModalButton>
    //     ];
    // }

    getData(v) {
        v = v || {};

        let data = [];
        Devices.forEach((d) => {
            WarningTypes.forEach((w) => {

                let tip1 = ""; let tip2 = ""; let tip3 = ""; let typeReason = "偏差"
                if (w.value == 1) {
                    tip1 = `重量连续3次超下限：`;
                    tip2 = `设定值：565 mg`;
                    tip3 = `当前重量：${getRandom(530, 550)} mg`;
                }

                if (w.value == 2) {
                    tip1 = `圆周连续3次超下限：`;
                    tip2 = `设定值：23.94 mg`;
                    tip3 = `当前重量：${getRandom(2313, 2393) / 100} mg`;
                }

                if (w.value == 3) {
                    tip1 = `当前 跑条 每百万 = ${getRandom(50, 60) / 10}`;
                    tip2 = `极限 = 4.8`;
                    tip3 = `产量 = ${threePosition(getRandom(1666840, 1777840))}`;
                    typeReason = "每百万 太高"
                }


                data.push({ Id: `${d.Id}_${w.value}_1`, Tip1: tip1, Tip2: tip2, Tip3: tip3, Type: w.value, TypeReason: typeReason, Time: `2021/07/01 ${Util.padLeft(getRandom(0, 23), 2, 0)}:${Util.padLeft(getRandom(0, 59), 2, 0)}`, Device: d });
                data.push({ Id: `${d.Id}_${w.value}_2`, Tip1: tip1, Tip2: tip2, Tip3: tip3, Type: w.value, TypeReason: typeReason, Time: `2021/07/02 ${Util.padLeft(getRandom(0, 23), 2, 0)}:${Util.padLeft(getRandom(0, 59), 2, 0)}`, Device: d });
                data.push({ Id: `${d.Id}_${w.value}_3`, Tip1: tip1, Tip2: tip2, Tip3: tip3, Type: w.value, TypeReason: typeReason, Time: `2021/07/03 ${Util.padLeft(getRandom(0, 23), 2, 0)}:${Util.padLeft(getRandom(0, 59), 2, 0)}`, Device: d });

            })
        });

        if (v.type) data = data.filter((t) => t.Type == v.type);
        if (v.device) data = data.filter((t) => t.Device.Id == v.device);
        return data;
    }

    search(v) {
        let data = this.getData(v);
        this.setState({ data: data })
    }

    mobileSearch(v, field) {
        this.searchArg[field] = v;
        this.search(this.searchArg);
        this.dataGrid.load();
    }

    render() {
        let data = this.state.data;
        return (
            <Modal ref={(r) => { this.modal = r; }} title="警报" size={"md"} containerFull={true}>
                <DataGrid ref={(r) => { this.dataGrid = r; }} className={DataGrid.modalClassName} data={{ rows: data }} headers={false} searchMaster="table" page={false} scrollable={true}
                    keyColumn={{ value: 'Id', text: 'TypeReason' }}
                    renderItem={(item, index) => {
                        return (
                            <DataCell className={"px-0 px-md-2 py-2"}>
                                <div className="d-flex flex-column">
                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                        <p className="mb-0 c-text-s2 text-dark font-weight-bold">{`${getWarningTypeText(item.Type)} ${item.TypeReason}`}</p>
                                        <p className="mb-0 c-text-s1d5 m-text-dark50">{item.Time}</p>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <p className="mb-0 c-text-s2 text-dark">{item.Device.Name}</p>
                                        <p className="mb-0 c-text-s1d5 m-text-dark50">{item.Tip1}</p>
                                        <p className="mb-0 c-text-s1d5 m-text-dark50">{item.Tip2}</p>
                                        <p className="mb-0 c-text-s1d5 m-text-dark50">{item.Tip3}</p>
                                    </div>
                                </div>
                            </DataCell>
                        )
                    }}
                    toolbar={<SearchBar searchMaster="table" title="搜索" onClick={(v) => { this.search(v); }}>
                        <Select field="type" label="类型" options={WarningTypes} width={200} mobileable={true}
                            variant="outlined" size={"small"} slave="table" onChange={runtime.mobile ? (v) => { this.mobileSearch(v, "type"); } : null} />
                        <Select field="device" label="设备" options={Devices.map((t) => { return { text: t.Name, value: t.Id } })}
                            mobileable={true} width={200} variant="outlined" size={"small"} slave="table" onChange={runtime.mobile ? (v) => { this.mobileSearch(v, "device"); } : null} />
                    </SearchBar>}
                />
            </Modal>
        )
    }
}


// const mapStateToProps = ({ Comparator }) => {
//     const { value } = Comparator;
//     return { value };
//   };

//   export const Comparator = connect(mapStateToProps, { onComparatorChange })(Warning);


function alert({ title, message, key }) {
    return (
        <div key={key} className="d-flex flex-column my-1">
            <Alert className="shadow-lg c-mb-0" color="danger">
                <div className="d-flex flex-row">
                    {createIcon(NotificationsActiveOutlinedIcon, "c-icon-s2d5")}
                    <div className="d-flex flex-column ml-2">
                        <h3 className="alert-heading">{title}</h3>
                        {message.map((m, index) => {
                            return <p key={`message-${index}`} className="mb-0 c-text-s1d5 my-1">{m}</p>
                        })}
                    </div>
                </div>
            </Alert>
        </div>
    );
}

export function danger({ title, message }) {
    return alert({ title, message });
}